<template>
    <b-container>
        <div v-if="loadError" class="text-danger firmware-load-error">{{$t('firmware_load_error')}}
            <b-button class="firmware-load-retry" :disabled="isBusy" @click="loadData">{{$t('retry')}}</b-button>
        </div>
        <div v-if="dataLoaded">
            <b-form-group v-for="field in fields" :key="field" :label="$t('firmware.info.' + (field === 'createdAt' ? 'created_at' : field))" :label-for="'firmware-' + field">
                <b-form-input :id="'firmware-' + field" :value="form[field]" disabled />
            </b-form-group>
            <FirmwareDownload :firmware="form" />
        </div>
    </b-container>
</template>

<script>
import axios from 'axios';
import FirmwareDownload from './FirmwareDownload.vue';
import { REQUEST_TIMEOUT_MS } from '../../utils/RequestGuard';
import { isRouteId } from '../../utils/FormValidation';

export default {
    name: 'FirmwareInfo',
    components: { FirmwareDownload },
    props: { id: { required: true } },
    data() {
        return { isBusy: false, dataLoaded: false, loadError: false, disposed: false, readVersion: 0,
            form: {}, fields: ['version', 'deviceType', 'description', 'createdAt'] };
    },
    methods: {
        async loadData() {
            if (this.disposed) return;
            const version = ++this.readVersion;
            this.isBusy = true; this.loadError = false; this.dataLoaded = false;
            try {
                if (!isRouteId(this.id)) throw new Error('Invalid firmware id');
                const { data } = await axios.get('api/v1/firmwares/' + this.id, { timeout: REQUEST_TIMEOUT_MS });
                if (this.disposed || version !== this.readVersion) return;
                if (!data || typeof data.version !== 'string' || typeof data.firmwareDownloadLink !== 'string') throw new Error('Invalid firmware');
                this.form = data; this.dataLoaded = true;
            } catch (error) {
                if (!this.disposed && version === this.readVersion && error.response?.status !== 401) this.loadError = true;
            } finally { if (!this.disposed && version === this.readVersion) this.isBusy = false; }
        },
    },
    watch: { id() { this.loadData(); } },
    mounted() { this.loadData(); },
    beforeDestroy() { this.disposed = true; this.readVersion++; },
};
</script>
